import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CSVLink } from "react-csv";
import { FiDownload } from "react-icons/fi";
import { useApi } from "../../services/api";

const PERIODS = [
  { key: "daily", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
];

export const ActiveUsersChart = () => {
  const { apiFetch } = useApi();
  const [period, setPeriod] = useState("daily");
  const [series, setSeries] = useState([]);

  useEffect(() => {
    async function loadData() {
      apiFetch("/api/analytics/activeUsers?period=" + period + "&days=30")
        .then((response) => response.json())
        .then((data) => {
          setSeries(data.series || []);
        })
        .catch(() => {
          alert("Error occured while loading active users");
        });
    }
    loadData();
  }, [period, apiFetch]);

  const options = {
    chart: { type: "line", height: 300 },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      categories: series.map((point) => point.date),
      tickInterval: 5,
    },
    yAxis: { title: { text: "Active users" }, allowDecimals: false },
    legend: { enabled: false },
    series: [
      {
        name: "Active users",
        data: series.map((point) => point.active_users),
        color: "#4A42A0",
      },
    ],
  };

  const csvData = series.map((point) => ({
    Date: point.date,
    "Active Users": point.active_users,
  }));

  return (
    <Card className="shadow" data-testid="activeUsersCard">
      <CardBody>
        <CardTitle style={{ textAlign: "left" }}>
          Active Users
          <span style={{ float: "right", display: "flex", alignItems: "center" }}>
            <CSVLink
              data={csvData}
              filename={"active_users_" + period + ".csv"}
              data-testid="activeUsersCsvLink"
              style={{ marginRight: "10px", display: "flex" }}
            >
              <FiDownload style={{ color: "#4A42A0" }} />
            </CSVLink>
            {PERIODS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setPeriod(item.key)}
                data-testid={"period-" + item.key}
                style={{
                  border: "none",
                  background: "none",
                  fontSize: "12px",
                  color: period === item.key ? "#4A42A0" : "#575757",
                  fontWeight: period === item.key ? "bold" : "normal",
                }}
              >
                {item.label}
              </button>
            ))}
          </span>
        </CardTitle>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </CardBody>
    </Card>
  );
};
